import { makeStyles } from '@mui/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress
} from '@mui/material';
import moment from 'moment';
import Loader from 'src/components/Generic/Loader';
import DowngradeStatusTag from './DowngradeStatusTag';
import StatusTag from 'src/containers/Reimbursements/common/data';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650
  },
  texthead: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#6B778C'
  },
  textbody: {
    fontSize: 14,
    color: '#172B4D'
  },
  tableContainer: {
    marginTop: 24
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: 5
  }
}));

const DowngradeRequestHistory = ({ requestData, loading }) => {
  const classes = useStyles();

  return (
    <div>
      {' '}
      <TableContainer className="table-container">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className={classes.texthead}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                Created At
              </TableCell>
              <TableCell className={classes.texthead}> Rem. ID</TableCell>
              <TableCell className={classes.texthead}>
                Approval Status
              </TableCell>
              <TableCell className={classes.texthead}>Current Status</TableCell>

              <TableCell className={classes.texthead}>
                Requested Status
              </TableCell>
              <TableCell className={classes.texthead}>Reseller</TableCell>
              <TableCell className={classes.texthead}>Customer</TableCell>
              <TableCell className={classes.texthead}>Mobile Number</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <div className="loader-pos">
                <CircularProgress color="error" />
              </div>
            ) : (
              <>
                {requestData && requestData?.length ? (
                  <>
                    {requestData.map((item, claimIndex) => {
                      return (
                        <>
                          <TableRow key={claimIndex}>
                            <TableCell className={classes.textbody}>
                              {moment(item?.createdOn).format('MMMM Do, YYYY')}
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              {item?.claimId}
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              <DowngradeStatusTag
                                status={item?.claimDecision}
                                size="md"
                              />
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              <StatusTag status={item?.currentStatus} />
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              <StatusTag status={item?.requestedstatus} />
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              {item?.resellerName}
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              {item?.memberName}
                            </TableCell>
                            <TableCell className={classes.textbody}>
                              {item?.memberMobileNumber}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                    {loading && <Loader />}
                  </>
                ) : (
                  <TableRow className="no-data" style={{ textAlign: 'center' }}>
                    <TableCell colSpan={4} className={classes.textbody}>
                      No Data
                    </TableCell>{' '}
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DowngradeRequestHistory;
